import React, { useState } from 'react';
import { t } from 'i18next';
import Dropdown from '../../../common/components/Dropdown';
import BulkEditModal from '../components/BulkEditModal';

export function AdControlContent(searchText, handleSearchChange, categories, sort, handleSortChange) {
    const [showBulkEdit, setShowBulkEdit] = useState(false);
    return (
        <div className="flex items-center gap-2 mt-4 mb-4">
            {/* Search */}
            <div className="flex-1 relative">
                <svg className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                <input
                    className="w-full pl-9 pr-4 py-2.5 text-sm bg-gray-50 border border-gray-200 rounded-xl outline-none focus:border-[#147F26] transition-colors"
                    placeholder={t('searchPlaceholder')}
                    value={searchText}
                    onChange={handleSearchChange}
                />
            </div>

            {/* Sort */}
            <div className="flex-shrink-0">
                <Dropdown
                    text={t('sortBy')}
                    options={[t('dateDesSort'), t('dateAscSort'), t('priceAscSort'), t('priceDesSort')]}
                    selected={sort || undefined}
                    onOptionSelect={handleSortChange}
                    width="s200"
                />
            </div>

            {/* Bulk Edit Button */}
            <div className="flex-shrink-0">
                <button
                    onClick={() => setShowBulkEdit(true)}
                    className="flex items-center gap-2 px-4 py-2.5 bg-[#147F26] hover:bg-[#0f5f1a] text-white text-sm font-medium rounded-xl transition-colors"
                >
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    {t('bulkEdit') || 'Массивті редакциялау'}
                </button>
            </div>

            {/* Bulk Edit Modal */}
            <BulkEditModal
                show={showBulkEdit}
                onClose={() => setShowBulkEdit(false)}
            />
        </div>
    );
}
